import {
	Component,
	OnInit,
	Input,
	Output,
	OnChanges,
	EventEmitter,
  } from '@angular/core';
  import { FormItem } from '../form/FormItem';
  import { FieldTypes } from '../../FieldTypes';
  import { FormGroup } from '@angular/forms';
  
  @Component({
	selector: 'vias-input',
	templateUrl: './input.component.html',
	styleUrls: ['./input.component.scss'],
  })
  export class InputComponent implements OnInit, OnChanges {
	@Input() item: FormItem;
	@Input() form: FormGroup;
	@Output() onclick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
	@Output() onchange: EventEmitter<object> = new EventEmitter<object>();
	inputType: string;
	multiline: boolean = false;
	matPrefix: boolean = false;
	matSuffix: boolean = false;
	appearance:string = 'outline';
	floatLabel:string = 'auto';
	inputWidthPercent: number = 0;
	constructor() {}
	ngOnInit(): void {
	  switch (this.item.type) {
		case FieldTypes.Number:
		  this.inputType = 'number';
		  break;
		case FieldTypes.Email:
		  this.inputType = 'email';
		  break;
		case FieldTypes.Password:
		  this.inputType = 'password';
		  break;
		case FieldTypes.Input:
		case FieldTypes.Text:
		case FieldTypes.Id:
		default:
		  this.inputType = 'text';
		  break;
	  }
	  if (this.item.multiline !== undefined) {
		this.multiline = this.item.multiline;
	  }
	  if(this.item.appearance && this.item.appearance !== undefined){
		this.appearance = this.item.appearance;
	  }
	  if(this.item.floatLabel && this.item.floatLabel !== undefined){
		this.floatLabel = this.item.floatLabel;
	  }
	  if (this.item.matPrefix !== undefined) {
		this.matPrefix = this.item.matPrefix;
	  }
	  if (this.item.matSuffix !== undefined) {
		this.matSuffix = this.item.matSuffix;
	  }
	  if (this.item.inputWidthPercent !== undefined) {
		this.inputWidthPercent = this.item.inputWidthPercent;
	  }
	  if (this.item.connectedValueSetFunction !== undefined) {
		if (this.item.name !== undefined) {
		  this.form.get(this.item.name).valueChanges.subscribe((val) => {
			this.form
			  .get(this.item.name)
			  .setValue(this.item.connectedValueSetFunction(val), {
				emitEvent: false,
			  });
		  });
		}
	  }
	}
	ngOnChanges(changes): void {}
	onClick($event: MouseEvent): void {
	  this.onclick.emit($event);
	}
	onChange($event: any): void {
	  const val: any = $event.currentTarget.value;
	  if (this.item.connectedValuesFormItems !== undefined) {
		this.item.connectedValuesFormItems.forEach((tItemName) => {
		  // console.log(this.form.controls[tItemName]);
		  this.form.controls[tItemName].setValue(val, { emitEvent: true });
		});
	  } else {
		this.onchange.emit(val);
	  }
	}
  }
  